<script>
import ImageArcGISRestSource from "ol/source/ImageArcGISRest";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import MapHelper from "./MapHelper";
import TileGrid from "ol/tilegrid/TileGrid";
import TileLayer from "ol/layer/Tile";
import XYZSource from "ol/source/XYZ";
import store from "../../store.js";
import ServiceHelper from "./ServiceHelper";
import { transformExtent } from "ol/proj";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import EsriJSON from "ol/format/EsriJSON";
import { tile as tileStrategy } from "ol/loadingstrategy";
import { createXYZ } from "ol/tilegrid";
import { intersects as intersectsExtent } from "ol/extent";

export default {
	getLods: function () {
		var lods = [{
			resolution: 1322.9193125052918,
			scale: 5000000
		}, {
			resolution: 793.7515875031751,
			scale: 3000000
		}, {
			resolution: 529.1677250021168,
			scale: 2000000
		}, {
			resolution: 264.5838625010584,
			scale: 1000000
		}, {
			resolution: 132.2919312505292,
			scale: 500000
		}, {
			resolution: 66.1459656252646,
			scale: 250000
		}, {
			resolution: 26.458386250105836,
			scale: 100000
		}, {
			resolution: 13.229193125052918,
			scale: 50000
		}, {
			resolution: 6.614596562526459,
			scale: 25000
		}, {
			resolution: 2.6458386250105836,
			scale: 10000
		}, {
			resolution: 1.3229193125052918,
			scale: 5000
		}, {
			resolution: 0.5291677250021167,
			scale: 2000
		}, {
			resolution: 0.26458386250105836,
			scale: 1000
		}, {
			resolution: 0.13229193125052918,
			scale: 500
		}];
		return lods;
	},
	getResolutions: function () {
		var resolutions = [];
		this.getLods().forEach(function (lod) {
			resolutions.push(lod.resolution);
		});
		return resolutions;
	},
	getResolutionForScale: function (scale) {
		var resolution;
		this.getLods().some(function (lod) {
			if (scale == lod.scale) {
				resolution = lod.resolution;
				return true;
			}
		});
		return resolution;
	},
	getProjection: function () {
		var projection = "EPSG:3346";
		return projection;
	},
	getBaseService: function () {
		var service = {
			title: "Žemėlapis",
			url: window.appConfig.background_service,
			base: true
		};
		return service;
	},
	getServiceCapabilities: function (url, type) {
		var promise = new Promise(function (resolve, reject) {
			setTimeout(function () {
				if (type == "esri") {
					window.fetch(url + "?f=json", {
						method: "GET"
					}).then(function (response) {
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function (text) {
						var json;
						if (text) {
							try {
								json = JSON.parse(text);
							} catch (err) {
								// ...
							}
						}
						if (json) {
							var capabilities = {
								type: "esri",
								content: json
							};
							resolve(capabilities);
						} else {
							reject();
						}
					}.bind(this), function () {
						reject();
					});
				} else {
					window.fetch("/map/webapp/rest/capservice", {
						method: "POST",
						body: JSON.stringify([{ url: url }]),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function (response) {
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function (text) {
						var json;
						if (text) {
							try {
								json = JSON.parse(text);
								if (Array.isArray(json) && json.length == 1) {
									json = json[0];
								} else {
									json = null;
								}
							} catch (err) {
								// ...
							}
						}
						if (json) {
							var capabilities = {
								type: "gisc",
								content: json
							};
							resolve(capabilities);
						} else {
							reject();
						}
					}.bind(this), function () {
						reject();
					});
				}
			}.bind(this), store.state.testDelay);
		});
		return promise;
	},
	getLayer(service, serviceCapabilitiesManager, fullExtent) {
		console.log("GET LAYER", service, serviceCapabilitiesManager); // TODO!..
		if (!serviceCapabilitiesManager) {
			serviceCapabilitiesManager = "esri";
		}
		var promise = new Promise(function (resolve, reject) {
			setTimeout(function () {
				if (service.layer) {
					resolve(service.layer);
				} else {
					if (service.url) {
						if (!service.rawOriginalUrl) { // Taip bus `tiled` sluoksnio atveju, kai darkart kviečiamas this.getLayer()!
							service.rawOriginalUrl = service.url; // To originalaus URL prireiks išsaugant žemėlapį, tiksliau išsaugant žemėlapio sluoksnius...
						}
						MapHelper.getServiceCapabilities(service.url, serviceCapabilitiesManager).then(function (capabilities) {
							if (!service.capabilities) {
								service.capabilities = {};
							}
							service.capabilities[capabilities.type] = capabilities.content; // Šito prireiks legendai (sluoksnių medžiui)
							var layer,
								json,
								extent = this.getExtent(service);
							if (fullExtent) {
								try {
									if (!intersectsExtent(extent, fullExtent)) {
										// Taip lyg ir buvo su http://192.168.166.27:8080/geoserver/Atlasas_Tema-2/wms
										console.warn("Layer extent and full extent don't intersect!..", service, extent, fullExtent);
										extent = fullExtent; // Nes jei naudosime tokį nesikertantį extent'ą, tai LT mums nekraus dominančio sluoksnio, kuriame bus panaudotas šis extent'as?
									}
								} catch (err) {
									console.warn("intersectsExtent error", extent, fullExtent, service);
									extent = fullExtent;
								}
							}
							if (service.capabilities["esri"]) {
								json = service.capabilities["esri"];
								if (json.singleFusedMapCache) {
									var resolutions = [];
									json.tileInfo.lods.forEach(function (lod) {
										resolutions.push(lod.resolution);
									});
									var wkid = json.spatialReference.wkid;
									if (wkid == 2600) {
										wkid = 3346;
									}
									layer = new TileLayer({
										source: new XYZSource({
											projection: "EPSG:" + wkid,
											tileUrlFunction: function (tileCoord) {
												var u = service.url + "/tile/" + tileCoord[0] + "/" + tileCoord[2] + "/" + tileCoord[1];
												return u;
											},
											tileGrid: new TileGrid({
												tileSize: [json.tileInfo.cols, json.tileInfo.rows],
												origin: [json.tileInfo.origin.x, json.tileInfo.origin.y],
												resolutions: resolutions
											})
										}),
										extent: extent
									});
								}
							} else if (service.capabilities["gisc"]) {
								json = service.capabilities["gisc"];
								if (!service.title) {
									service.title = json.title; // Pavadinimo nebus, kai sluoksnį pridedame per URL!
								}
								var params;
								switch (json.type) {
									case "AGS":
									case "AIS":
										if (json.type == "AIS" && !json.defaultSpatialReference) {
											// Įdomus dalykas! HNIT'ų capService'as "AIS" tipą grąžina ir blogiems/nepasiekiamiems servisams???... Reikia būti atsargiems!
											// Šiaip blogas servisas `defaultSpatialReference` neturėjo... Tai gal šios savybės pagalba galima diferencijuoti, ar turime gerą AIS servisą, ar tai "blogo serviso" atvejis?
											break;
										}
										service.url = json.url;
										if (json.tiled) {
											this.getLayer(service, "esri").then(function (layer) {
												resolve(layer);
											}, function () {
												reject();
											});
											return;
										} else {
											var dummyUrlStart = "DUMMY/MapServer";
											params = {};
											if (service.layers) {
												params.layers = service.layers;
											} else {
												var layerId = service.rawOriginalUrl.replace(json.serviceUrl, "");
												layerId = layerId.replace(/^\//, ""); // Lygtais yra buvę ir taip?..
												layerId = parseInt(layerId);
												if (!isNaN(layerId)) {
													params.layers = "show:" + layerId;
												}
											}
											layer = new ImageLayer({
												source: new ImageArcGISRestSource({
													ratio: 1,
													url: dummyUrlStart, // Toks "dummy" paduodamas, nes "The url should include /MapServer or /ImageServer", o capService'as grąžina modifikuotą URL be to... Metodu `imageLoadFunction` situaciją atitaisysime!
													imageLoadFunction: function (image, src) {
														if (json.type == "AIS") {
															src = src.replace("/export?", "/exportImage?"); // Hmmm... Lygtais OL to nesuvaldo... Kodėl?..
														}
														src = src.replace(dummyUrlStart, service.url);
														image.getImage().src = src;
													},
													params: params
												}),
												extent: extent
											});
										}
										break;
									case "WMS":
										params = {
											"VERSION": "1.1.1"
										};
										if (service.layers) {
											params.layers = service.layers;
										} else {
											this.reverseChildrenRecursively(json.layer);
											var sublayers = this.getWmsSublayers(json.layer.children);
											params.layers = sublayers.join(",");
										}
										layer = new ImageLayer({
											source: new ImageWMS({
												url: json.url,
												ratio: 1,
												imageLoadFunction: function (image, src) {
													if (src.indexOf("layers=&") != -1) {
														image.getImage().src = "/map/resources/libs/arcgis_js/esri/images/pixel.png";
													} else {
														image.getImage().src = decodeURIComponent(src); // Be decode'inimo piešinukas nepasiekiamas?..
													}
												},
												params: params
											}),
											extent: extent
										});
										break;
									default:
									// ...
								}
							}
							if (layer) {
								layer.service = service;
								service.layer = layer;
								resolve(layer);
							} else {
								reject();
							}
						}.bind(this), function () {
							reject();
						});
					} else {
						if (service.id) { // TODO: ar gali būti service.id lygus nuliui??... Jei taip, tai ši sąlyga niekada nebus true! Blogai...
							if (service.type == "edvi-vector") {
								service.url = ServiceHelper.edviItemVector + service.id;
								MapHelper.getServiceCapabilities(service.url, "esri").then(function (capabilities) {
									if (!service.title) {
										service.title = capabilities.content.name;
									}
									service.capabilities = capabilities;
									var esriJsonFormat = new EsriJSON(),
										projectionCode = 3346; // TODO: imti iš map'o kažkokių nustatymų?
									var vectorSource = new VectorSource({
										loader: function (extent, resolution, projection) {
											var u = service.url + '/query/?f=json&' +
												'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
												encodeURIComponent('{"xmin":' + extent[0] + ',"ymin":' +
													extent[1] + ',"xmax":' + extent[2] + ',"ymax":' + extent[3] +
													',"spatialReference":{"wkid":"' + projectionCode + '"}}') +
												'&geometryType=esriGeometryEnvelope&inSR=' + projectionCode + '&outFields=*' +
												'&outSR=' + projectionCode;
											window.fetch(u, {
												method: "GET"
											}).then(function (response) {
												return response.text();
											}).then(function (text) {
												if (text) {
													let json;
													try {
														json = JSON.parse(text);
													} catch (err) {
														// ...
													}
													var features = esriJsonFormat.readFeatures(json, {
														featureProjection: projection
													});
													if (features.length > 0) {
														vectorSource.addFeatures(features);
													}
												}
											});
										},
										strategy: tileStrategy(createXYZ({
											tileSize: 512
										}))
									});
									var layer = new VectorLayer({
										source: vectorSource
									});
									layer.service = service;
									service.layer = layer;
									resolve(layer);
								}, function () {
									reject();
								});
							} else if (service.type == "edvi-raster") {
								service.url = ServiceHelper.edviItemRaster.replace("{datasetId}", service.id);
								MapHelper.getServiceCapabilities(service.url, "esri").then(function (capabilities) {
									if (!service.capabilities) {
										service.capabilities = {};
									}
									service.capabilities[capabilities.type] = capabilities.content;
									if (!service.title) {
										service.title = capabilities.content.name;
									}
									var layer = new ImageLayer({
										source: new ImageArcGISRestSource({
											ratio: 1,
											url: service.url,
											params: {
												dynamicLayers: JSON.stringify([{
													source: {
														type: "dataLayer",
														dataSource: {
															type: "raster",
															workspaceId: capabilities.content.rasterWorkspaceId,
															dataSourceName: capabilities.content.rasterDataSourceName
														}
													},
													id: 0
												}])
											}
										}),
										extent: this.getExtent(service)
									});
									layer.service = service;
									service.layer = layer;
									resolve(layer);
								}.bind(this), function () {
									reject();
								});
							} else {
								// Aktualu išsaugotiems žemėlapio sluoksniams?...
								ServiceHelper.search(service.id).then(function (records) {
									var success = false;
									if (records) {
										records.forEach(function (record) {
											if (!success && record.type && record.documents) {
												record.documents.forEach(function (document) {
													var attributes = document.attributes;
													if (!success && attributes && attributes.length == 1 && attributes[0].actions) {
														attributes[0].actions.some(function (action) {
															if (action.tag == "addToMap") { // TODO, FIXME! Čia šiek tiek pasikartojantis kodas su SearchResult'u...
																var url = action.url;
																url = url.replace(/(.*)?#portalAction=openService&serviceUrl=/, "");
																url = decodeURIComponent(url);
																service.url = url;
																service.title = document.title;
																service.meta = document; // Prireiks sluoksnio nustatymų skiltyje "Turinyje"
																this.getLayer(service, "gisc", fullExtent).then(function (layer) {
																	resolve(layer);
																}, function () {
																	reject();
																});
																success = true;
																return true;
															}
														}.bind(this));
													}
												}.bind(this));
											}
										}.bind(this));
									}
									if (!success) {
										reject();
									}
								}.bind(this));
							}
						} else {
							reject(); // TODO...
						}
					}
				}
			}.bind(this), 2000);
		}.bind(this));
		return promise;
	},
	getWmsSublayers(children) {
		var sublayers = [];
		if (children) {
			children.forEach(function (child) {
				if (child.id != null) {
					sublayers.push(child.id);
				}
				if (child.children) {
					sublayers = sublayers.concat(this.getWmsSublayers(child.children));
				}
			}.bind(this));
		}
		return sublayers;
	},
	reverseChildrenRecursively(layer) {
		if (!layer || !layer.children) return;

		// Apverčiam šio lygio vaikus
		layer.children.reverse();

		// Pereinam per visus vaikus ir apverčiam jų vaikus
		layer.children.forEach(child => this.reverseChildrenRecursively(child));
	},
	getExtent(service) {
		var capabilities = service.capabilities,
			extent;
		if (capabilities) {
			capabilities = capabilities["esri"] || capabilities["gisc"];
			if (capabilities) {
				var extentConfig = capabilities.fullExtent || capabilities.initialExtent;
				if (capabilities.layer && capabilities.layer.children && capabilities.layer.children.length == 1) {
					var child = capabilities.layer.children[0];
					if (child.extents && child.extents.length == 1) {
						extentConfig = child.extents[0];
					}
				}
				extent = this.getExtentFromExtentConfig(extentConfig) || undefined;
			}
		}
		return extent;
	},
	getExtentFromExtentConfig: function (extentConfig) {
		var extent;
		if (extentConfig) {
			try {
				var wkid = extentConfig.spatialReference.latestWkid || extentConfig.spatialReference.wkid;
				if (wkid == 2600) {
					wkid = 3346;
				}
				if (wkid == 4326) {
					// FIXME! Pratestuoti šį veikimą! Atsirado po Andriaus 2020-09-21 laiško... "https://apptest/inspire-widgets/v2/atlas/73bb4879-342d-490a-a8a6-45ec5a674af5/view"
					extent = [extentConfig.xmin, extentConfig.ymin, extentConfig.xmax, extentConfig.ymax];
					if (extentConfig.xmin > extentConfig.ymin) {
						extent = [extentConfig.ymin, extentConfig.xmin, extentConfig.ymax, extentConfig.xmax];
					}
				} else {
					extent = [extentConfig.xmin, extentConfig.ymin, extentConfig.xmax, extentConfig.ymax];
				}
				extent = transformExtent(extent, "EPSG:" + wkid, this.getProjection());
			} catch (err) {
				console.log("ERR", err, extent, wkid);
				extent = null;
			}
		}
		return extent;
	}
}
</script>